import experience$1 from './v2/index.js';
import experience$2 from './v3/index.js';
import experience$3 from './v4/index.js';
export { MyListAssetType } from './types.js';
import './v2/learnActions.js';
import './v3/recommendation.js';
import './v3/playback.js';
import './v4/playback.js';
import './v4/recommendation.js';
import './v4/learnActions.js';

function experience(backendAxiosInstance) {
  return {
    v2: experience$1(backendAxiosInstance),
    v3: experience$2(backendAxiosInstance),
    v4: experience$3(backendAxiosInstance)
  };
}

export { experience as default };
//# sourceMappingURL=index.js.map
